import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { isExternalHref } from "../../constants";

const PillButton = ({
  label,
  href,
  variant = "ghost",
  startIconClass,
  openInNewTab = false,
}) => {
  const external = isExternalHref(href);
  const newTab = external || openInNewTab;
  const variantClass =
    variant === "primary"
      ? "edsimsV2-pill-button--primary"
      : variant === "soft"
      ? "edsimsV2-pill-button--soft"
      : "edsimsV2-pill-button--ghost";

  return (
    <Button
      component={external ? "a" : RouterLink}
      href={external ? href : undefined}
      to={external ? undefined : href}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noopener noreferrer" : undefined}
      size="small"
      startIcon={
        startIconClass ? (
          <i className={startIconClass} aria-hidden="true" />
        ) : undefined
      }
      className={[
        "edsimsV2-pill-button",
        variantClass,
        variant === "primary" && startIconClass
          ? "edsimsV2-pill-button--with-icon"
          : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label}
      {newTab ? (
        <span className="edsimsV2-sr-only">(opens in a new tab)</span>
      ) : null}
    </Button>
  );
};

export default PillButton;
